// import './moire-bg';
import './moire-bg-ribbons.js';

jQuery(function ($) {
  console.log('XXXXX started');
});
